import { render, staticRenderFns } from "./PTable.vue?vue&type=template&id=ddb3bf28&scoped=true&"
import script from "./PTable.vue?vue&type=script&lang=ts&"
export * from "./PTable.vue?vue&type=script&lang=ts&"
import style0 from "./PTable.vue?vue&type=style&index=0&id=ddb3bf28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb3bf28",
  null
  
)

export default component.exports